/**
 * Author:Murugaeswari
 * Modified by:kani,Murugaeswari
 * Modified Date: 2025-05-05
 */
// PricingPlans.js
import React, { useRef, useEffect, useState } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Label, Input, FormFeedback ,Row,Col} from "reactstrap";
import * as Yup from "yup";
import { getLoggedInUser } from "../../helpers/fakebackend_helper"
import * as url from "../../../src/helpers/url_helper";
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import axios from "axios";
import {RAZORPAY_KEY} from '../../constants/commonVariable'
import Spinners from "../../components/Common/Spinner";
import './PricingPlans.css';
import Checkout from './checkout'; 

import ConfirmModal from "../../components/Common/ConfirmModal";
export default function WelcomeComp() {
  const scrollRef = useRef();
  const checkoutRef = useRef();
  const [showScrollButtons, setShowScrollButtons] = useState(false);
  const [planList, setPlanList] = useState([]);
 
  const [isLoading, setLoading] = useState(false);


  
  const checkOverflow = () => {
    const el = scrollRef.current;
    if (el) {
      setShowScrollButtons(el.scrollWidth > el.clientWidth);
    }
  };
  const handleSubscribeClick = (plan) => {
    if (checkoutRef.current) {
      checkoutRef.current.checkProfileCompetion(plan);
    }
  };

  const scroll = (direction) => {
    if (scrollRef.current) {
      const { scrollLeft, clientWidth } = scrollRef.current;
      scrollRef.current.scrollTo({
        left: direction === 'left' ? scrollLeft - clientWidth : scrollLeft + clientWidth,
        behavior: 'smooth',
      });
    }
  };
  useEffect(() => {
    getPlanList();
   
    checkOverflow();
    window.addEventListener('resize', checkOverflow);
    return () => window.removeEventListener('resize', checkOverflow);
  }, []);



  const getPlanList = async () => {
    const user = getLoggedInUser()
    const data = {
      stid: Number(user.UserInfo.stid),
    }
    setLoading(true);
    const config = { headers: { authorization: 'Bearer '.concat(user.UserInfo.accessToken) } };
    try {
      const response = await axios.post(url.BASE_URL + 'subscription/getSubscriptionPlanList', data, config);
      if (response && response?.data?.body?.statusFlag === 3) {
        toast.error(response.data.body.message, { autoClose: 2000 });
        localStorage.removeItem("authUser");
        window.location.reload();
        return;
      }
      setLoading(false);

      if (response?.data?.body?.status === '401' || response?.data?.body?.status === 401) {
        const refresh = await getRefreshToken();
        if (refresh) {
          if (Number(refresh) === constants.invalidRefreshToken) {
            logoutUser();
          } else {
            await getPlanList();
          }
        }
      }

      let plancolor = ['#EC407A','#005B77','#26c6DA','#FFC107'];
      if (response?.data?.body?.planList) {
        const formattedPlans = response?.data?.body?.planList?.map((plan,index) => {
          return {
            title: ` ${plan.plan_name}`,
            price: `₹${plan.amount} / ${plan.validity_in_days} days`,
            color: plancolor[index % plancolor.length], // you can customize this
            features: plan?.feature?.split('|').map(text => ({
              text: text.trim(),
              included: true
            })),
            category_id: plan.category_id,
            plan_id: plan.plan_id,
            subCount : plan.studsub_count,
            validity_in_days : plan.validity_in_days,
            "total_questions": plan.total_questions,
            "mark_per_question": plan.mark_per_question,
            "test_duration": plan.test_duration,
            "total_marks": plan.total_marks,
          };
        
        });
        setPlanList(formattedPlans);
      } else {
        setLoading(false);
        // toast.error(response.data.body.message, { position: toast.POSITION.TOP_RIGHT });
      }
    } catch (error) {
      setLoading(false);
      // Handle error
      console.error("student detailsAPI Error:", error);
    }
  }
  return (
    <div className="pricing-wrapper   " >
            <Checkout ref={checkoutRef} />
      <div style={{ fontSize: '20px', fontWeight: 'bold' , padding:'0px 0px 16px 0px'}} >Subscription Plans</div>
      {planList && planList.length == 0 &&
                <div className="col-12 col-md-6 col-lg-3 mb-4 d-flex">
                  
                      <div style={{ fontSize: '14px', fontStyle: 'italic' }}>No plans found.</div>
                   
                  </div>

              }
         {/* {showScrollButtons && (
        <button className="scroll-btn left" onClick={() => scroll('left')}>&lt;</button>
      )} */}

      <div className="pricing-scroll" ref={scrollRef}>
        {planList?.map((plan, idx) => (
          <div key={idx} className="pricing-card"  >
            <div
              className="pricing-ribbon"
              style={{ backgroundColor: plan?.color }}
            >
              {plan.price}
            </div>
            {Number(plan?.subCount)>0 && 
            <div
              
              style={{position:'absolute',left:-10, top:6, backgroundColor: 'green', color:'#fff', borderRadius:5, padding:'4px', width:'fit-content', fontSize:12 }}
            >
              {'Subscribed'}
            </div>}
            <h3 className="pricing-title" style={{ color: plan?.color }}>
              {plan.title}
            </h3>
            <ul className="pricing-features">
              {plan?.features?.map((feature, i) => (
                <li key={i} className={feature.included ? 'included' : 'excluded'}>
                  {feature.included ? '✔' : '✘'} {feature.text}
                </li>
              ))}
            </ul>
            <button
              className="pricing-btn"
              onClick={() => handleSubscribeClick(plan)}
              style={{ backgroundColor: plan?.color }}
            >
              SUBSCRIBE
            </button>
          </div>
        ))}
      </div>
      {/* {showScrollButtons && (
        <button className="scroll-btn right" onClick={() => scroll('right')}>&gt;</button>
      )} */}

   
    </div>

    
  );
}
